import React from 'react';
import GOT from '../utils/GOT';
import GOTUtil from '../utils/GOTUtil';
import QueryUtil from '../utils/QueryUtil';

import StringUtil from '../utils/StringUtil';
import RecordsUtil from '../utils/RecordsUtil';


import FormLookupRenderFactory from '../utils/FormLookupRenderFactory';
import FormItemConst from '../formItem/FormItemConst';
import LookupRefreshStore from '../stores/LookupRefreshStore';
import {LookupasteriskRefreshStore} from '../stores/LookupStores';
import {RecordsCmpStore,GroupCurrentRecordChangedStore} from '../stores/RecordsStore';
import FormDataSources from '../datasource/FormDataSources';
import {LookupHostKeydownStore} from '../stores/LookupStores';
import LookupActions from '../actions/LookupActions';

import {AutoFormLookupHeaderClickSortStore} from '../stores/QueryStores';
import FormLookupFactory from '../utils/FormLookupFactory';
import GOTPropertiesUtil from '../utils/GOTPropertiesUtil';
import CommonUtil from '../utils/CommonUtil';

import AutoLookupStringEditor from './autoLookup/AutoLookupStringEditor';
import AutoLookupLongEditor from './autoLookup/AutoLookupLongEditor';
import AutoLookupDateEditor from './autoLookup/AutoLookupDateEditor';

import LookupSortableHeaderCell from './LookupHeaderCell';
import AutoLookupDecimalEditor from './autoLookup/AutoLookupDecimalEditor';
import FormItemFieldGroup from '../formItem/FormItemFieldGroup';



const ReactDataGrid = require('react-data-grid');

class FormLookup extends React.Component
{
	  constructor(props) 
	  {
	  	super(props);
	  	this.entityId = this.props.entityId;
	  	this.innerId = this.props.innerId;
	  	this.lookupKey = this.entityId+"."+this.innerId;
	  	this.classAlias = "FormLookup";
	  	
		this._extralsWhereItemsRefresh = null;
		this._joinQueryWhereItems = [];
	  	this.queryBoxClear = this.queryBoxClear.bind(this);
	  	this.unsubscribeLookupCmpStore = 
			LookupRefreshStore.listen(this.onDataProviderRefresh.bind(this));
		this.unsubscribeLookupasteriskRefreshStore = 
			LookupasteriskRefreshStore.listen(this.onAsteriskRefresh.bind(this));
		/*this.unsubscribeLookupHostKeydownStore = 
			LookupHostKeydownStore.listen(this.onLookupHostKeydown.bind(this));*/

		this.unsubscribeRecordsCmpStore = RecordsCmpStore.listen(this.onExecuteCmp.bind(this));
		this.unsbuscribeAutoFormLookupHeaderClickSortStore = AutoFormLookupHeaderClickSortStore.listen(this.onGridHeaderClick.bind(this));
		this.dataType = this.props.dataType;
	  	var dataTypeRelation = this.dataType.DataTypeRelation;
	  	var mainTablePro = dataTypeRelation.Properties.Table;
	  	var mainTable = null;
		if(mainTablePro.hasOwnProperty("refentityid"))
		{
			mainTable = GOT.getTable(mainTablePro.refentityid);
		}

		var dataTypeRelationNormalItem = GOT.getDataTypeRelationNormalItem(dataTypeRelation);

		var dataTypeRelationFixed = GOT.getDataTypeRelationFixedItem(dataTypeRelation);

		this.dataTypeRelationNormalItem = dataTypeRelationNormalItem;
		this.dataTypeRelationFixed = dataTypeRelationFixed;
		this.dataTypeRelation = dataTypeRelation;
		this.mainTable = mainTable;
		
		this.returnField = this.getReturnField(dataTypeRelationNormalItem,mainTable);
		this.autoReturn = true;
		this.autoQueryFields = [];
		var tableFields = this.getAutoLookupFields(mainTable);
		var totalWidth = 0;var columns = [];
		for(var i in tableFields)
		{
			var tableField = tableFields[i];
			var type = tableField.type;
			var name = tableField.name;
			//var column = {};
			if(type == "Component")
			{
				var items = GOT.getComponentItems(tableField);
				var tempComponent2ArrayItem = tableField.tempComponent2ArrayItem;
				for(var i in items)
				{
					var item = items[i];
					if(tempComponent2ArrayItem && item.name != tempComponent2ArrayItem)
						continue;
					var refPro = item.Properties.RefDataType;
					if(refPro.hasOwnProperty("refentityid"))
					{
						var subName = StringUtil.convertToFirstLowerCase(name) + "." + 
							StringUtil.convertToFirstLowerCase(item.name);
													
						var dataType = GOT.getDataType(refPro.refentityid);
						_dataField = mainTable.name + "." + subName;
						_label = GOTUtil.getFinalValue(dataType,dataType,"Label");
						let column = {};
						column.name =_label;column.editable = false;column.resizable = true;column.key = _dataField;
						var render = FormLookupRenderFactory.getLookupRender(dataType.type,_dataField,dataType.id,null);
						column.formatter = render;
						_width = GOTUtil.getFinalValue(dataType,dataType,"DisplayLength") * FormItemConst.displayLength_EN + FormItemConst.displayLength_ENAddon;
						column.width = _width;totalWidth+=_width;
						column.headerRenderer = <LookupSortableHeaderCell lookupKey={this.entityId+"."+this.innerId}/>;
						columns.push(column);
					}
				}
			}
			else
			{
				let column = {};
				var _dataField = mainTable.name + "." + StringUtil.convertToFirstLowerCase(name);
				var _label = tableField.hasOwnProperty("shortcut")?"快捷码":GOTUtil.getFinalValue(tableField,mainTable,"Label");
				var render = FormLookupRenderFactory.getLookupRender(type,_dataField,mainTable.id,tableField.id);
				var displayLength = GOTUtil.getFinalValue(tableField,mainTable,"DisplayLength");
				var _width = Number(displayLength) * FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon;totalWidth+=_width;column.width = _width;
				column.formatter = render;column.name = _label;column.key = _dataField;column.editable = false;column.resizable = true;
				column.headerRenderer = <LookupSortableHeaderCell lookupKey={this.entityId+"."+this.innerId}/>;
				columns.push(column);
			}
		}
		
	    this._columns = columns;
	    this.formXML = JSON.parse(JSON.stringify(FormLookupFactory.formLookupXMLTemplate));
	    this.setFormDataSources();
	  	this.state = { rows:[], selectedIndexes: [], scrollmax:0 ,gridContainerWidth:totalWidth+35,updateMinHeight:-1,containerWidth100:true};
	  }

	  componentWillUnmount()
	  {
	  	this.unsubscribeLookupCmpStore();
	  	this.unsubscribeLookupasteriskRefreshStore();
	  	//this.unsubscribeLookupHostKeydownStore();
		this.unsubscribeRecordsCmpStore();
		this.unsbuscribeAutoFormLookupHeaderClickSortStore();
	  	this.formDataSources.componentWillUnmount();
	  }

	  onExecuteCmp(data,groupAlias,group)
	  {
	    if(this.formDataSources.firstGroup == group)
	    {
		  this.waitingInitFocus = true;
		  let baseFilter = this.lookupArg["baseFilter"];
		  let mainField = this.lookupArg["fieldName"];
		  let selectIndex = 0;
		  if(data && baseFilter && mainField)
		  {
			  for(let i = 0;i<data.length;i++)
			  {
				let record = data[i];
				let mainDataField = this.mainTable.name+"."+StringUtil.convertToEachFirstLowerCase(mainField);
				let mainDataFieldValue = record[mainDataField];
				if(mainDataFieldValue == baseFilter)
				{
					selectIndex = i;break;
				}
			  }
		  }
		  this.setState({ rows:data,selectedIndexes:[selectIndex]});
		  if(selectIndex>0)
		  	this.scrollToIndex(selectIndex,true);

		  //this.forceUpdate();
	      // if(data && data.length>0)
	      // {
	      // 	this.grid.doOnSelect({rowIndex:0,idx:0,active:false});
      	// 	$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Cell.row-selected")[0].focus();
	      // }
	    }
	  }

	  setFormDataSources()
	  {
	  	var formDataSource = this.formXML.FormDataSources.DataSources[0];
			
		var tablePro = formDataSource.Properties["Table"];
		tablePro.refentityid = this.mainTable.id;
		tablePro.Value = this.mainTable.name;
		//自动构建的下拉换面的别名就是表名 不存在关联表 肯定不会重复 其被用作后台查询的数据的键值
		//与dataGrid中列的dataField也是一致
		formDataSource.name = this.mainTable.name;
		this.formDataSources = new FormDataSources(this.formXML.FormDataSources,this,true);
	  }

	  getReturnField(dataTypeRelationNormalItem,mainTable)
	  {
		var fieldValue = dataTypeRelationNormalItem.Properties.Field.V;
		if(fieldValue=="")
		{
			throw new Error("miss FieldValue");
		}
		return mainTable.name + "." + fieldValue.substr(0,1).toLowerCase()+fieldValue.substr(1);
	  }

	  getAutoLookupFields(mainTable)
	  {			
			var tableFields = [];
			var tableField;
			var fieldPro;
			var allTableFields = mainTable.TableFields.TableField;
			var autoTableFieldGroup = GOT.getAutoTableFieldGroup(mainTable);
		    var thisTableFieldId = this.dataTypeRelationNormalItem?this.dataTypeRelationNormalItem.Properties.Field.refinnerid:"";
			for(var i in autoTableFieldGroup.FieldGroupItems)
			{
				var tableFieldGroupItem = autoTableFieldGroup.FieldGroupItems[i];
				fieldPro = tableFieldGroupItem.Properties.Field;
				var innerid = fieldPro.innerid;
				tableField = GOT.getTableField(mainTable,innerid);
				

				if(!tableField)
					throw new Error("GOT设置错误 在AutoLookup的GroupItem上找不到TableField");

				if(tableFieldGroupItem.Properties.Visible && (tableFieldGroupItem.Properties.Visible.V ==false || tableFieldGroupItem.Properties.Visible.V =='false')){
					continue;
				}
				var autoQueryField = tableFieldGroupItem.Properties.AutoQueryField.V;
				if(autoQueryField == "true")
				{
					this.autoQueryFields.push(tableField);
					var focusIn = tableFieldGroupItem.Properties.FocusIn.V;
					if(focusIn == "true")
						tableField.focusIn = focusIn;
				}
				if(tableField.type == "Component")
				{
					let arrayItem = GOTUtil.getPropertyValue(tableFieldGroupItem,"ArrayItem");
					if(arrayItem)
					{
						tableField.tempComponent2ArrayItem = arrayItem;
					}
				}

				var joinQuery = GOTUtil.getPropertyValue(tableFieldGroupItem,"JoinQuery");
				if((typeof(joinQuery)=="boolean"&&joinQuery==true)
					|| joinQuery == "true")
				{
					//let tableFieldGroupItemFieldId = tableFieldGroupItem.Properties.Field.innerid;
					//if(tableFieldGroupItemFieldId != thisTableFieldId)
					//{
						this._joinQueryWhereItems.push(tableField);
					//}
				}
				tableFields.push(tableField);
			}
			
			if(tableFields.length == 0)
			{
				fieldPro = mainTable.Properties.TitleField1;
				
				if(fieldPro && fieldPro.hasOwnProperty("innerid"))
				{
					let innerid = fieldPro.innerid;
					tableField = GOT.getTableField(mainTable,innerid);
					if(!tableField)
						throw new Error("GOT设置错误 在TitleField1上找不到TableField");
					tableFields.push(tableField);
				}
				fieldPro = mainTable.Properties.TitleField2;
				if(fieldPro && fieldPro.hasOwnProperty("innerid"))
				{
					let innerid = fieldPro.innerid;
					tableField = GOT.getTableField(mainTable,innerid);
					if(!tableField)
						throw new Error("GOT设置错误 在TitleField2上找不到TableField(存在innerid)");
					tableFields.push(tableField);
				}
			}
			
			
			var index;
			var indexItem;
			var indexes;
			if(tableFields.length == 0)
			{
				fieldPro = mainTable.Properties.ClusterIndex;
				if(fieldPro.hasOwnProperty("innerid"))
				{
					let innerid = fieldPro.innerid;
					index = GOT.getTableIndex(mainTable,innerid);
					
					for(let i in index.TableIndexItem)
					{
						indexItem = index.TableIndexItem[i];
						fieldPro = indexItem.Properties.Field;
						if(fieldPro.hasOwnProperty("innerid"))
						{
							tableField = GOT.getTableField(mainTable,fieldPro.innerid);
							tableFields.push(tableField);
						}
					}
					
				}
			}
			
			if(tableFields.length == 0)
			{
				if(this.dataTypeRelationNormalItem)
				{
					fieldPro = this.dataTypeRelationNormalItem.Properties.Field;
					if(fieldPro.hasOwnProperty("refinnerid"))
					{
						tableField = GOT.getTableField(mainTable,fieldPro.refinnerid);
						tableFields.push(tableField);
					}
				}
			}
			
			fieldPro = mainTable.Properties.ShortCutField;
			if(fieldPro && fieldPro.hasOwnProperty("innerid"))
			{
				tableField = GOT.getTableField(mainTable,fieldPro.innerid);
				if(tableFields.indexOf(tableField) == -1)
				{
					tableField.shortcut = true;
					tableFields.push(tableField);
				}
			}
			
			return tableFields;
	  }

	  rowGetter(i) {
	    return this.state.rows[i];
	  }

	  rowClick(index,record,proxy)
	  {
		if(index == -1)return;
	  	//alert("点击");
	  	var datas = this.state.rows;
	  	var returnItem = datas[index];
	  	var returnValue = returnItem[this.returnField];
	  	LookupActions.lookupReturn(returnValue,this.props.entityId,this.props.innerId);
	  }

	  gridKeyDown(proxy)
  	  {
  	  	if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
	    {
	      let ne = proxy["nativeEvent"];
	      if(ne.keyCode == 40 || ne.keyCode == 38)
	      {
			if(ne.ctrlKey)
				return false;
	      	this.moveSelectVertical(ne.keyCode);
	      	return true;
	        /*var newSelectIndexes = this.state.selectedIndexes;
	        if(newSelectIndexes.length == 0)
	        {
	          if(this.state.rows.length>0)
	          {
	            newSelectIndexes.push(0);
	          }
	        }
	        else
	        {
	          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
	          let newIndex = ne.keyCode==40?lastIndex+1:lastIndex-1;
	          let total = this.state.rows.length;
	          if(newIndex>=0&&newIndex<total)
	          {
	            newSelectIndexes = [newIndex];
	          }
	        }

	        this.setState({selectedIndexes:newSelectIndexes});
	        return true;*/
	      }
	      else if(ne.keyCode == 13)
	      {
	    	var datas = this.state.rows;
	    	if(!datas || datas.length==0)
	    		return;
	    	var index = 0;
	    	if(this.state.selectedIndexes && this.state.selectedIndexes.length>0)
	    		index = this.state.selectedIndexes[this.state.selectedIndexes.length-1];
		  	var returnItem = datas[index];
		  	var returnValue = returnItem[this.returnField];
		  	LookupActions.lookupReturn(returnValue,this.props.entityId,this.props.innerId);
	      }
	    }
  	  }

  	  scrolling(arg)
  	  {
  	  	try
  	  	{
  	  		if(this.scrollState && arg.scrollLeft!=this.scrollState.scrollLeft)
	        {
		      //是横向滚动条 不需要动态加载数据
		      this.scrollState.scrollLeft = arg.scrollLeft;
		      return;
	        }
		    console.log(arg);
		    var _divdom = arg.dom;
		    if(_divdom)
		    {
			  var scrollTop,maxScroll,minScroll=0;
			  scrollTop = _divdom.scrollTop;
		      maxScroll = _divdom.scrollHeight - _divdom.clientHeight;
	      	  console.log(scrollTop+"------------"+maxScroll);
		  	  if(scrollTop >= (maxScroll-2))
	      	  {
		          // var addrows = this.createRows(50,50);
		          // var rows = this.state.rows.slice();
		          // var newrows = rows.concat(addrows);
		          // this.setState({rows:newrows,scrollmax:0}); 
		          if(this.formDataSources.firstGroup)
		          {
		          	this.formDataSources.firstGroup.scrollEndNextPage();
		          }
		      }
		      else if(scrollTop <=0){
			  
		      }
		    }
  	  	}
  	  	catch(e)
  	  	{

  	  	}
	  }

	  scrollToIndex(index,first = false)
	  {
		//alert(this.grid.props.rowHeight);
		if(index == undefined)
			index = 30;
		var targetTop = this.grid.props.rowHeight*(index+1);
		var _dom = this.grid.base.viewport.canvas.rowsContainerDiv;
		//var scroll_offset = $(_dom).offset(); //得到pos 这个div层的offset，包含两个值，top和left
		
		var screenFirstRow = _dom.scrollTop/this.grid.props.rowHeight;
		var screenLastRow = screenFirstRow+(_dom.clientHeight/this.grid.props.rowHeight);
		if(index>screenLastRow)
			targetTop-=_dom.clientHeight;
		else if(index>screenFirstRow)
			return;
		else
			targetTop-=this.grid.props.rowHeight;
		var maxScroll = _dom.scrollHeight - _dom.clientHeight;
		if(targetTop>maxScroll)targetTop = maxScroll;
		if(first)
		{
			targetTop += (_dom.clientHeight-this.grid.props.rowHeight);
		}
		setTimeout(function(){
				$(_dom).animate({
				scrollTop:targetTop //让body的scrollTop等于pos的top，就实现了滚动 
			},10); 
		},100);
	}

	  addFilterField(group,arg)
	  {
		if(!this.dataTypeRelation)
			  return;
		var queryWhereItemTemplate = 
		{
			qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
			Properties:
			{
				Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
				RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
			}
		};
		let _baseFilter = this.lookupArg["baseFilter"];
		let mainQueryWhereItem = null;
		//TODO 输入星号导致的查询 包括了输入*号导致下拉 以及 下拉已经存在的情况下输入*号
		if(arg && arg.isInputAsteriskRefresh)
		{
			var queryWhere = group.currentQuery.QueryTable.QueryWhere;
			var queryWhereItem = JSON.parse(JSON.stringify(queryWhereItemTemplate));// Object.assign({},queryWhereItemTemplate);
			var fieldPro = queryWhereItem.Properties.Field;
			var valuePro = queryWhereItem.Properties.Value;
			var mainFieldName = this.lookupArg["fieldName"];
			var mainField = GOT.getTableField(this.mainTable,mainFieldName);
			if(mainField)
			{
				fieldPro.refentityid = this.mainTable.id;
				fieldPro.refinnerid = mainField.id;
				fieldPro.V = mainField.name;
				valuePro.V = this.lookupArg["baseFilter"];
				//TODO 用户输入*号后 如果通配符不是星号 过滤条件中应该把*号变成通配符
				// if(FormItemConst.WILDCARD != "*" && valuePro.V)
				// {
				// 	valuePro.V = valuePro.V.replace(/\*/g,FormItemConst.WILDCARD);
				// }
				if(!queryWhere.Items)queryWhere.Items = [];
				queryWhere.Items.push(queryWhereItem);
				mainQueryWhereItem = queryWhereItem;
			}
		}

		//QueryOnTyping时也加入JoinQuery条件
		if(this._joinQueryWhereItems 
			&& this._joinQueryWhereItems.length>0 
			&& group.currentQuery
			&& _baseFilter && _baseFilter.indexOf("*") != -1
		)
		{
			let _length = this._joinQueryWhereItems.length;
			var queryWhere = group.currentQuery.QueryTable.QueryWhere;
			var skipEnum = 0;
			for(let i = 0;i<_length;i++)
			{
				var tableField = this._joinQueryWhereItems[i];
				var queryWhereItem = JSON.parse(JSON.stringify(queryWhereItemTemplate));//Object.assign({},queryWhereItemTemplate);
				
				var fieldPro = queryWhereItem.Properties.Field;
				var valuePro = queryWhereItem.Properties.Value;
				
				fieldPro.refentityid = this.mainTable.id;
				fieldPro.refinnerid = tableField.id;
				if(tableField.type != "Component")
					fieldPro.V = tableField.name;
				else 
					fieldPro.V = GOTUtil.getPropertyValue(tableField,"ArrayItem");
				//2022-03 如果像输入
				if(tableField.type == "Enum")
				{
					let enumItems = GOTUtil.getDataSourceByTableField(tableField);
					let _baseFilter = this.lookupArg["baseFilter"];var resultArr = [];
					//_baseFilter   *xxx  *xxxx* xxx*
					if(_baseFilter)//把*号去掉
					{
						let reg = new RegExp("[\\"+FormItemConst.WILDCARD+"]{1,}","g");
						let _baseFilter2 = _baseFilter.replace(reg,"");
						var x_left = new RegExp(_baseFilter2 + ".*");
						var x_right = new RegExp(".*" +  _baseFilter2);
						var x_mid = new RegExp(".*"+_baseFilter2+".*");
						var _statrWidth = _baseFilter.indexOf(FormItemConst.WILDCARD) == 0;
						var _endWidth =  _baseFilter.indexOf(FormItemConst.WILDCARD) == _baseFilter.length-1;
						if (_statrWidth || _endWidth) 
						{// 若输入为 *xxx* 或 *xxx 或 xxx*
							if (_statrWidth && _endWidth)  
							{	 // 若输入为 *xxx*
								for ( let i = 0 ; i < enumItems.length ; i ++) 
								{
									let enumItem = enumItems[i];
									var result = enumItem.label.match(x_mid);
									if(result && result.length>0)
									{
										resultArr.push(enumItem.value);
									}
								}
							}
							else if (_endWidth) 
							{		// 若输入为 xxx*
								for(let i = 0;i<enumItems.length;i++)
								{
									let enumItem = enumItems[i];
									var result = enumItem.label.match(x_left);
									if(result && result.length>0)
									{
										resultArr.push(enumItem.value);
									}
								}
							}
							else if (_statrWidth) 
							{		// 若输入为 *xxx
								for(let i = 0;i<enumItems.length;i++)
								{
									let enumItem = enumItems[i];
									var result = enumItem.label.match(x_right);
									if(result && result.length>0)
									{
										resultArr.push(enumItem.value);
									}
								}
							}
						}
						//alert(resultArr.join(","));
						
					}
					valuePro.V = resultArr.join(",");
					if(valuePro.V == ""){skipEnum++;continue;}
				}
				else
				{
					valuePro.V = this.lookupArg["baseFilter"];
				}
				if(!queryWhere.Items)queryWhere.Items = [];
				queryWhere.Items.push(queryWhereItem);
				queryWhereItem.Properties.AndOr.V = "Or";
				/*if(i==0)//第一个
				{
					if(mainQueryWhereItem)
					{
						mainQueryWhereItem.Properties.LeftBracket.V = "(";
					}
				}
				if(i == _length - 1)//最后一个
				{
					queryWhereItem.Properties.RightBracket.V = ")";
				}*/
			}

			if(_length-skipEnum>0)
			{
				if(mainQueryWhereItem){mainQueryWhereItem.Properties.LeftBracket.V = "(";}
				queryWhere.Items[queryWhere.Items.length-1].Properties.RightBracket.V = ")";
			}
		}
		var filterfieldPro = this.dataType.DataTypeRelation.Properties.FilterField;
		if(!filterfieldPro.hasOwnProperty("refentityid"))
			return;
		
		if(this._extralsWhereItemsRefresh && this._extralsWhereItemsRefresh.length>0 && group.currentQuery)
		{
			var queryWhere = group.currentQuery.QueryTable.QueryWhere;
			for(let i = 0;i<this._extralsWhereItemsRefresh.length;i++)
			{
				var queryWhereItemValue = this._extralsWhereItemsRefresh[i];
				var queryWhereItem = JSON.parse(JSON.stringify(queryWhereItemTemplate));//Object.assign({},queryWhereItemTemplate);
				
				var fieldPro = queryWhereItem.Properties.Field;
				var valuePro = queryWhereItem.Properties.Value;
				
				fieldPro.refentityid = filterfieldPro.refentityid;
				fieldPro.refinnerid = filterfieldPro.refinnerid;
				fieldPro.V = filterfieldPro.V;
				
				valuePro.V = queryWhereItemValue;
				if(!queryWhere.Items)queryWhere.Items = [];
				queryWhere.Items.push(queryWhereItem);
			}
		}
		
		if(this._extralsAggregationItemsRefresh && this._extralsAggregationItemsRefresh.length>0 && group.currentQuery)
		{
			var queryAggregations = group.currentQuery.QueryTable.QueryAggregations;
			for(let i = 0;i<this._extralsAggregationItemsRefresh.length;i++)
			{
				var queryAggregationItemValue = this._extralsAggregationItemsRefresh[i];

				/*<QueryAggregation name="ItemId#Distinct" id="2" createdLayer="sys" modifiedLayer="sys">
					<Properties>
						<Property refentityid="30000030" refinnerid="30">
						<Name>Field</Name>
						<Value>ItemId</Value>
						</Property>
						<Property>
						<Name>Aggregation</Name>
						<Value>Distinct</Value>
						</Property>
					</Properties>
				</QueryAggregation>*/

				var queryAggregationItem = 
				{
					qname:"QueryAggregation",name:"",id:"",tag:"autoAppendForFormModuleLookup",
					Properties:
					{
						Field:{V:filterfieldPro.V,refentityid:filterfieldPro.refentityid,refinnerid:filterfieldPro.refinnerid},
						Aggregation:{V:queryAggregationItemValue}
					}
				};
				
				
				if(!queryAggregations.Items)queryAggregations.Items = [];
				queryAggregations.Items.push(queryAggregationItem);
			}
			
		}


	  }

	  onGridHeaderClick(columnKey,_sortDirection,lookupKey)
	  {
		
		if(lookupKey == (this.entityId+"."+this.innerId))
		{
			var group = this.formDataSources.firstGroup;
			if(!group)
			{
				var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
				group = this.formDataSources.groups[firstDataSourceName];
			}
			if(group)
			{
				group.sortForLookup(columnKey,_sortDirection,true,true);
			}
		}
	  }

	  doDataProviderRefresh(arg)
	  {
	  	var group = this.formDataSources.firstGroup;
		if(!group)
		{
			var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
			group = this.formDataSources.groups[firstDataSourceName];
		}
		if(group)
		{
			group.reSetCurrentQuery();
			if(this.lookupArg["asteriskLookupQuery"])
			{
				this.lookupArg["asteriskLookupQuery"]=false;
				if(!arg)arg={};
				arg.isInputAsteriskRefresh = true;
			}
			this.addFilterField(group,arg);
			group.executeQueryAutoSaveStop(null,null,false,false,false,arg);
			//this.executeQuery(group);
		}
		else
		{
			throw new Error("FormModuleLookup refresh not find group");
		}
	  }

	  beforeClose()
	  {
		let canvas = $(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Canvas")[0];
		if(canvas)canvas.scrollTop=0;
	  }

	  onDataProviderRefresh(entityId,innerId)
	  {
	  	if(this.entityId!=entityId || this.innerId != innerId)
			  return;
			  
		//let canvas = $(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Canvas")[0];
		//if(canvas)canvas.scrollTop=0;

	  	this.doDataProviderRefresh();
	  }

	  rpcDataProviderRefresh(formDataSourceGroupResult)
	  {
		var finalDatas = RecordsUtil.getOneLevelDatas(formDataSourceGroupResult,this.mainTable.name);
      	this.setState({ rows:finalDatas, selectedIndexes: [0], scrollmax:0 });
	  }

	  //输入*号导致了查询
	  onAsteriskRefresh(entityId,innerId,filter)
	  {
	  	if(this.entityId != entityId || this.innerId != innerId)
	  		return;
	  	this.lookupArg["baseFilter"] = filter;
	  	this.doDataProviderRefresh({appendFilter:true,isInputAsteriskRefresh:true});
	  }

	  queryBoxClear()
	  {

	  }

	  setExtralAggregationItemValueForRefresh(append=false,...params)
	  {
		if(append == true)
		{
			if(this._extralsAggregationItemsRefresh == null)
				this._extralsAggregationItemsRefresh = [];
		}
		else
		{
			this._extralsAggregationItemsRefresh = [];	
		}
		
		for(var i in params)
		{
			var item = params[i];
			this._extralsAggregationItemsRefresh.push(item);
		}
	  }

	  setExtralWhereItemValueForRefresh(append=false,...params)
	  {
		if(append == true)
		{
			if(this._extralsWhereItemsRefresh == null)
				this._extralsWhereItemsRefresh = [];
		}
		else
		{
			this._extralsWhereItemsRefresh = [];	
		}
		
		for(var i in params)
		{
			var item = params[i];
			this._extralsWhereItemsRefresh.push(item);
		}
	  }

	  onLookupHostKeydown(lookupKey,e)
	  {
	  	if(this.props.lookupKey == lookupKey)
	  	{
	  		this.moveSelectVertical(e.keyCode);
	  		let methodName = 'onPress' + e.key;
	  		if (typeof this.grid[methodName] === 'function') {
		      this.grid[methodName](e);
		    }
	  	}
	  }

	  moveSelectVertical(keyCode)
	  {
	  	if(keyCode == 40 || keyCode == 38)
      	{
	        let record = null;
	        var newSelectIndexes = this.state.selectedIndexes;
	        if(newSelectIndexes.length == 0)
	        {
	          if(this.state.rows.length>0)
	          {
	            record = keyCode == 40?this.state.rows[0]:this.state.rows[this.state.rows.length-1];
	            newSelectIndexes.push(0);
	          }
	        }
	        else
	        {
	          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
	          let newIndex = keyCode==40?lastIndex+1:lastIndex-1;
	          let total = this.state.rows.length;
	          if(newIndex>=0&&newIndex<total)
	          {
	            record = this.state.rows[newIndex];
	            newSelectIndexes = [newIndex];
	          }
	        }
	        var selected = this.grid.state.selected;
	        var colIndex = 0;
	        if(selected)
	        	colIndex = selected.idx;
	        var rowIndex = (newSelectIndexes&&newSelectIndexes.length>0)?newSelectIndexes[0]:0;
	        this.setState({selectedIndexes:newSelectIndexes});
        	
        	//this.grid.doOnSelect({rowIndex:rowIndex,idx:colIndex,active:false});	
	       	//$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Row.row-selected>.react-grid-Cell.row-selected")[colIndex].focus();
	        //console.log("rowIndex:"+rowIndex+"   newSelectIndexes"+JSON.stringify(newSelectIndexes));
	        //this.grid.doOnSelect({idx:idx,rowIdx:rowIdx,active:false});

    	}
	  }

	  componentDidMount()
	  {
	  	//alert(this.entityId+" "+this.innerId);
		for(var key in this.formDataSources.groups)
		{
			var group = this.formDataSources.groups[key];
			group.initFormQuery();
			
		}
		//根据dataTypeRelationItem中的Fixed，补充QueryWhereItem
		this.addFixedWhereItem();
		this.addSysActiveWhereItem();
		this.addshortcutWhereItem();

		this.bindResize(this.outterDiv?this.outterDiv:this.refs["datagridcontainer"+this.entityId+this.innerId]);
			//document.getElementById("selectedLookup"));
	  }

	  componentDidUpdate()
	  {
		if(this.waitingInitFocus == true)
		{
			this.waitingInitFocus = false;
			var selectedCells = $(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Cell.row-selected");
			if(selectedCells.length==0)
			{
				return;
			}
		
			this.grid.doOnSelect({idx:1,rowIdx:0,active:false});
			selectedCells[0].focus();
		}
	  }

	  addshortcutWhereItem()
	  {
		var shortcutfield = GOTUtil.getShortCut(this.mainTable);
		if(shortcutfield != null)
		{
			var group = this.formDataSources.firstGroup;
			var queryWhere = group.formQuery.QueryTable.QueryWhere;
			if(!queryWhere.Items)queryWhere.Items = [];
			var queryWhereItem = 
			{
				qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
               	Properties:
               	{
	               	Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
	                RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
                }
    		};
			queryWhereItem.tag = "shortcut";
			var fieldPro = queryWhereItem.Properties.Field;
			var valuePro = queryWhereItem.Properties.Value;
			
			fieldPro.refentityid = this.mainTable.id;
			fieldPro.refinnerid = shortcutfield.id;
			fieldPro.V = shortcutfield.name;
			
			valuePro.Value = "";
			
			queryWhere.Items.push(queryWhereItem);
		}
	  }
	
	  addSysActiveWhereItem()
	  {
		if(!this.formDataSources)
			throw new Error("formDataSources");
		var group = this.formDataSources.firstGroup;
		if(group.formQuery)
		{	
			var dataType = this.dataType;
			var sysactivePro = dataType.Properties.SysActive || dataType.Properties.FilterSysActive;
			if(!sysactivePro)
				return;
			var queryWhere = null;var queryWhereItem;var fieldPro;var valuePro;
			if(sysactivePro.V=="true" || sysactivePro.V==true)
			{
				var tableFields = this.mainTable.TableFields;

				for(let i = 0;i<tableFields.length;i++)
				{
					var tableField = tableFields[i];
					//暂时这样判断是继承系统SysActive
					if((tableField.name=="SysActive" || tableField.name=="Active") && GOTUtil.getPropertyValue(tableField, "Extends")=="SysActive")
					{
						if(queryWhere == null)
							queryWhere = group.formQuery.QueryTable.QueryWhere;
						queryWhereItem = 
						{
							qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
			               	Properties:
			               	{
				               	Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
				                RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
			                }
			    		};
						
						queryWhereItem.tag = "sysactive";
						fieldPro = queryWhereItem.Properties.Field;
						valuePro = queryWhereItem.Properties.Value;
						
						fieldPro.refentityid = this.mainTable.id;
						fieldPro.refinnerid = tableField.id;
						fieldPro.V = tableField.name;
						valuePro.V = true;
						if(!queryWhere.Items)queryWhere.Items = [];
						queryWhere.Items.push(queryWhereItem);
						break;
					}
				}
			}
		}
	  }
	
	  addFixedWhereItem()
	  {
		if(!this.formDataSources)
			throw new Error("formDataSources");
		var group = this.formDataSources.firstGroup;
		if(group.formQuery)
		{
			if(this.dataTypeRelationFixedItems && dataTypeRelationFixedItems.length() > 0)
			{
				var queryWhere = group.formQuery.QueryWhere;
				var queryWhereItem;var fieldPro;var valuePro;var relationItemFieldPro;var relationItemValuePro;
				for(let i = 0;i<this.dataTypeRelationFixedItems.length;i++)
				{
					var dataTypeRelationFixedItem = this.dataTypeRelationFixedItems[i];
					queryWhereItem = 
					{
						qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
		               	Properties:
		               	{
			               	Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
			                RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
		                }
		    		};
					queryWhereItem.tag = "fixed";
					fieldPro = queryWhereItem.Properties.Field;
					valuePro = queryWhereItem.Properties.Value;
					relationItemFieldPro = dataTypeRelationFixedItem.Properties.Field;
					relationItemValuePro = dataTypeRelationFixedItem.Properties.FixedValue;
					fieldPro.refentityid = relationItemFieldPro.refentityid;
					fieldPro.refinnerid = relationItemFieldPro.refinnerid;
					fieldPro.V = relationItemFieldPro.V;
					valuePro.V = relationItemValuePro.V;
					if(!queryWhere.Items)queryWhere.Items = [];
					queryWhere.Items.push(queryWhereItem);
				}
				var formQueryCopy = JSON.parse(JSON.stringify(group.formQuery));
				group.reSetCurrentQuery(formQueryCopy);
	
			}
			
		}
		
	  }

	  closeHandler()
	  {
	  	LookupActions.popDropDownClose(this.entityId,this.innerId);
	  }

	  lookupOnKeyDown(e)
	  {
		if(e.keyCode == 27 || (e.ctrlKey && e.keyCode == 38))
		{
			this.closeHandler();
		}
	  }

	  onRowsSelected = rows => {
		this.setState({
		  selectedIndexes: this.state.selectedIndexes.concat(
			rows.map(r => r.rowIdx)
		  )
		});
	  }
	
	  onRowsDeselected = rows => {
		let rowIndexes = rows.map(r => r.rowIdx);
		this.setState({
		  selectedIndexes: this.state.selectedIndexes.filter(
			i => rowIndexes.indexOf(i) === -1
		  )
		});
	  }
	  
	  returnSelectionData()
	  {
		let indexes = this.state.selectedIndexes;
		if(!indexes || indexes.length < 1)
			return;
		let returnValue= "";
		var datas = this.state.rows;
		for(let i = 0;i<indexes.length;i++)
		{
			let index = indexes[i];
			let returnItem = datas[index];
			let returnValueSingle = returnItem[this.returnField];
			if(i==0)
			{
				returnValue+=returnValueSingle;
			}
			else
			{
				returnValue+=(","+returnValueSingle)
			}
		}
		
		//returnValue = returnItem[this.returnField];
		LookupActions.lookupReturn(returnValue,this.props.entityId,this.props.innerId);
	  }

	  getGridDom(hasQueryList)
	  {
		let selectionObj = {
			showCheckbox: false,
			enableShiftSelect: true,
			selectBy: {
			  indexes: this.state.selectedIndexes
			}
		};
		
		let tmpMinW = this.state.gridContainerWidth+20;
		let _style = {minWidth:(tmpMinW<200?200:tmpMinW)+'px',height:'250px',alignSelf:'stretch'};
		if(!hasQueryList && !this.props.isPop)
		{
			//_style.paddingLeft = "5px";
			_style.paddingRight = "5px";
		}
		let buttonDom = null;let minHeight = 250;
		if(this.props.formType == "Query")
		{
			selectionObj.showCheckbox = true;
			selectionObj.onRowsSelected = this.onRowsSelected;
			selectionObj.onRowsDeselected = this.onRowsDeselected;
			_style.minWidth = (tmpMinW<220?220:tmpMinW+20)+'px';_style.height = '280px';
			//minHeight = 330;
			buttonDom = <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-end',alignItems:'center',height:'30px'}}>
							<button style={{backgroundColor:'rgb(245, 166, 35)',fontSize:'14px',border:'1px solid rgb(245, 166, 35)',color:'#fff',borderRadius:'2px'}} onClick={this.returnSelectionData.bind(this)}>返回选中行所有</button>
						</div>;
		}
		let _rowHeight = FormItemConst.DATAGRID_ROW_HEIGHT;
		let _headerRowHeight = FormItemConst.DATAGRID_ROW_HEIGHT;
		if(window.formCustomConfigs && window.formModuleInstance)
		{
			let formName = window.formModuleInstance.formName;
			if(window.formCustomConfigs.hasOwnProperty(formName))
			{
				let _config = window.formCustomConfigs[formName];
				if(_config)
				{
					if(_config.autoLookupRowHeight)_rowHeight = _config.autoLookupRowHeight;
					if(_config.autoLookupHeaderRowHeight)_headerRowHeight = _config.autoLookupHeaderRowHeight;
				}
			}
		}
	  	return (
		    <div className={'datagridcontainer FormLookup_Grid_Container'} style={_style}
		    	 ref={"datagridcontainer"+this.entityId+this.innerId} onKeyDown={this.lookupOnKeyDown.bind(this)}>
		      	<ReactDataGrid
					ref={ node => this.grid = node }
		        	onRowClick={this.rowClick.bind(this)}
		       		onGridKeyDown={this.gridKeyDown.bind(this)}
					numColumn={true}
					columns={this._columns.slice()}
					enableCellSelect={true}
					rowGetter={this.rowGetter.bind(this)}
					rowsCount={this.state.rows.length}
		        	rowHeight={_rowHeight}
		        	headerRowHeight={_headerRowHeight}
					onScroll={this.scrolling.bind(this)}
					minHeight={minHeight}
					containerWidth100={this.state.containerWidth100}
					fixedContainerWidth={this.fixedContainerWidth}
					rowSelection={selectionObj}
				/>
				{buttonDom}
		    </div>
		  );
	  }

	  getQueryListDom()
	  {
	  	if(this.autoQueryFields && this.autoQueryFields.length>0)
	  	{	
	  		let _getEditor = this.getEditor.bind(this);
	  		return this.autoQueryFields.map(function(item)
	  		{
	  			return _getEditor(item);
	  		});
	  	}
	  	else
	  	{
	  		return null;	
	  	}
	  	
	  }

	  getEditor(item)
	  {
	  	let editorType = item.type;
	  	let itemProperties = GOTPropertiesUtil.getItemPropertyFinalValue(null,this.mainTable.id,item.id,this.mainTable);
	  	let _displayLength = itemProperties.DisplayLength;
	  	let _id = CommonUtil.guid();
	  	if(editorType == "String")
	  	{
	  		return <AutoLookupStringEditor displayLength={_displayLength} id={_id} key={item.id} label={itemProperties.Label} 
					lookupKey={this.lookupKey} tableField = {item} trim={itemProperties.Trim} changeCase={itemProperties.ChangeCase}
					stringSize={itemProperties.StringSize} regular={itemProperties.Regular} initFocus={item.focusIn}/>
	  	}
	  	else if(editorType == "Long")
	  	{
	  		return <AutoLookupLongEditor displayLength={_displayLength} id={_id} key={item.id} label={itemProperties.Label}
	  				allowNegative={itemProperties.AllowNegative} showZero={itemProperties.ShowZero} thousandSeperator={itemProperties.ThousandSeperator}
	  				lookupKey = {this.lookupKey} tableField = {item} initFocus={item.focusIn}/>
	  	}
	  	else if(editorType == "Date")
	  	{
	  		return <AutoLookupDateEditor displayLength={_displayLength} id={_id} key={item.id} label={itemProperties.Label}
	  				show1970={itemProperties.Show1970} seperator={itemProperties.Seperator} numOfDay={itemProperties.NumOfDay}
	  				numOfMonth={itemProperties.NumOfMonth} numOfYear={itemProperties.NumOfYear} lookupKey={this.lookupKey} tableField = {item} initFocus={item.focusIn}/>
		}
		else if(editorType == "Decimal")
//AllowNegative: false DisplayHeight: 1 DisplayLength: 11 Label: "Bair" NumOfDecimals: 2 Regular: "" RoundOff: "HalfUp" ShowDecimals: 0 ShowZero: true ThousandSeperator: false
		{
			return <AutoLookupDecimalEditor displayStyle={itemProperties.displayStyle} displayLength={_displayLength} id={_id} key={item.id} label={itemProperties.Label}
					numOfDecimals={itemProperties.NumOfDecimals} allowNegative={itemProperties.AllowNegative}  roundOff={itemProperties.RoundOff} thousandSeperator={itemProperties.ThousandSeperator} showZero={itemProperties.ShowZero}
					lookupKey={this.lookupKey} tableField = {item} initFocus={item.focusIn}/>
		}
	  }

	  queryHandler()
	  {
	  	let args = {};
	  	LookupActions.lookupAutoQuery(this.lookupKey,args);
	  	var group = this.formDataSources.firstGroup;
		if(!group)
		{
			var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
			group = this.formDataSources.groups[firstDataSourceName];
		}
		if(!group)
			return;
	  	group.reSetCurrentQuery();
	  	for(let key in args)
	  	{
			let _value = args[key];
	  		QueryUtil.createWhereItemByField(key,key,this.mainTable.name,group.currentQuery,_value);
	  	}
		group.executeQueryAutoSaveStop();
	  }

	  queryClear()
	  {
	  	var group = this.formDataSources.firstGroup;
		if(!group)
		{
			var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
			group = this.formDataSources.groups[firstDataSourceName];
		}
		if(!group)
			return;
	  	group.reSetCurrentQuery();
	  	group.executeQueryAutoSaveStop();
	  }

	  resizeMouseDown(el,e)
	  {
		var offset = el.offsetParent;
		var	x = 0;
		var y = 0;
		var right_x = e.pageX - offset.offsetLeft - el.offsetWidth; //获得鼠标指针离DIV元素左边界的距离
		var bottom_y = e.pageY - offset.offsetTop - el.offsetHeight; //获得鼠标指针离DIV元素上边界的距离
		if ((right_x < -5  || right_x > 5)) {
			return;
		}
		//按下元素后，计算当前鼠标与对象计算后的坐标  
		x = e.clientX - el.offsetWidth, y = e.clientY - el.offsetHeight;
		let columns = this._columns;
		let lastColumn = (columns && columns.length>0)?columns[columns.length-1]:null;
		let _resizeMouseMove = this.resizeMouseMove.bind(this,x,e.clientX,lastColumn?lastColumn.width:-1);
		let _resizeMouseUp = this.resizeMouseUp.bind(this,el);
		//在支持 setCapture 做些东东  
		el.setCapture ? (
		//捕捉焦点   
		el.setCapture(),
		//设置事件   
		el.onmousemove = _resizeMouseMove,
		el.onmouseup = _resizeMouseUp
		) : (
		//绑定事件   
		$(document).bind("mousemove", _resizeMouseMove).bind("mouseup", _resizeMouseUp)
		)
		//防止默认事件发生   
		e.preventDefault()
	  }

	  resizeMouseMove(x,origX,startWidth,e)
	  {
		e=e||event;
		let columns = this._columns;
		if(columns)columns=columns.slice();
		let lastColumn = (columns && columns.length>0)?columns[columns.length-1]:null;
		//let nowWidth = e.clientX-x;
		if(lastColumn)
		{
			lastColumn = Object.assign({},lastColumn);
			lastColumn.width=(startWidth+e.clientX-origX);
			columns.splice(columns.length-1,1,lastColumn);
			this._columns=columns;
		}
		
		let _gridContainerWidth = e.clientX - x;
		this.fixedContainerWidth = _gridContainerWidth;
		this.setState({
			gridContainerWidth: _gridContainerWidth
		});
	  }

	  //停止事件   
	  resizeMouseUp(el,e) 
	  {
		//在支持 releaseCapture 做些东东   
		el.releaseCapture ? (
		//释放焦点   
		el.releaseCapture(),
		//移除事件   
		el.onmousemove = el.onmouseup = null
		) : (
		//卸载事件   
		$(document).unbind("mousemove").unbind("mouseup")
		)
	  }

	  bindResize(el) {
		//初始化参数   
		var els = el.style;
		//鼠标的 X 和 Y 轴坐标   
		
		//el.style.cursor = "e-resize";
		el.childNodes[0].style.cursor = "text";
		$(el).mousedown(this.resizeMouseDown.bind(this,el));
	  }   

	  render() 
	  {
		 let queryListDom = this.getQueryListDom();
		 let hasQueryList = queryListDom?true:false;
		 let gridDom = this.getGridDom(hasQueryList);
		 let resizeDom = <div style={{position:'absolute',right: 0,
		 					bottom:0,height:'100%',width:'5px',cursor:'e-resize'}}></div>;
	     if(this.props.isPop)
	     {
	     	if(!queryListDom)
	     	{
	     		return(<div ref={node=>this.outterDiv=node} style={{alignSelf:"center",border:"2px solid #e5e5e5",borderRadius:"2px",paddingRight:"5px",paddingLeft:"5px"}}>
		              <div className="modal-header" style={{background:"#ffffff",padding:"5px",position:"relative",height:"30px"}}>
		              	<i className="fa fa-close" style={{position:"absolute",top:"7px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closeHandler.bind(this)}></i>
		              </div>
		              {resizeDom}
		              {gridDom}
	        	  </div>);	
	     	}
	     	else
	     	{
	     		return(<div ref={node=>this.outterDiv=node} style={{alignSelf:"center",border:"2px solid #e5e5e5",borderRadius:"2px",paddingRight:"5px",paddingLeft:"5px"}}>
		              <div className="modal-header" style={{background:"#ffffff",padding:"5px",position:"relative",height:"30px"}}>
		              	<i className="fa fa-close" style={{position:"absolute",top:"7px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closeHandler.bind(this)}></i>
		              </div>
		              {resizeDom}
		              <div style={{display:'flex',flexDirection:'column'}}>
		              	<div style={{display:'flex',flexDirection:'row',marginTop:'5px',marginBottom:'5px'}}>
		     				{queryListDom}
		     				<div style={{marginLeft:'10px',display:'flex',flexDirection:'row'}}>
		     					<button ref={node => this.btnQuery = node} className='btn btn-info' onClick={this.queryHandler.bind(this)} style={{height:FormItemConst.EDITOR_HEIGHT+'px'}}>查询</button>
		     					<button ref={node => this.btnQuery = node} className='btn btn-info' onClick={this.queryClear.bind(this)} style={{height:FormItemConst.EDITOR_HEIGHT+'px',marginLeft:'5px'}}>重置</button>
		     				</div>
	     				</div>
	     					{gridDom}
	     			  </div>
	        	  </div>);	
	     	}
	     	
	     }
	     else
	     {
	     	if(queryListDom)
	     	{
	     		return <div ref={node=>this.outterDiv=node} style={{display:'flex',flexDirection:'column',paddingRight:'5px',paddingLeft:'5px'}}><div style={{display:'flex',flexDirection:'row',marginTop:'5px',marginBottom:'5px'}}>
	     				{queryListDom}
	     				<div style={{marginLeft:'10px',display:'flex',flexDirection:'row'}}>
	     					<button ref={node => this.btnQuery = node} className='btn btn-info' onClick={this.queryHandler.bind(this)} style={{height:FormItemConst.EDITOR_HEIGHT+'px'}}>查询</button>
	     					<button ref={node => this.btnQuery = node} className='btn btn-info' onClick={this.queryClear.bind(this)} style={{height:FormItemConst.EDITOR_HEIGHT+'px',marginLeft:'5px'}}>重置</button>
	     				</div>
						 {resizeDom}
	     				</div>
	     					{gridDom}
	     				</div>;	
	     	}
	     	else
	     	{
	     		return gridDom;
	     	}
	     	
	     }
	  }
};
FormLookup.defaultProps = {
};

module.exports=FormLookup;


// WEBPACK FOOTER //
// ./src/components/FormLookup.js